import { observer } from 'mobx-react-lite';
import TopicForm from '../components/TopicForm';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/common/Tabs';
import { ITEM_TAB } from '@/pages/seo-tool';
import SeoSetting from '@/pages/seo-tool/components/SeoSetting';
import { SEO_ENTITY_TYPE } from '@/configs/constants';
import { useStore } from '@/hooks/useStore';
import { useParams } from 'react-router-dom';

export default observer(function TopicEditPage() {
    const [activeTab, setActiveTab] = useState('information_setting');
    const { t } = useTranslation();

    const handleTabChange = (tabValue: string) => {
        setActiveTab(tabValue);
    };
    const { code } = useParams();

    const { topicStore: { getTopicDetail, setObservable } } = useStore();

    // lifecycle
    useEffect(() => {
        if (code) {
            getTopicDetail(code);
        }

        return () => {
            setObservable('topicDetail', null);
        };
    }, []);

    const TAB_KEY = {
        INFORMATION_SETTING: 'information_setting',
        SEO_SETTING: 'seo_setting'
    };
    const SEO_TOOL_TAB_TYPE: ITEM_TAB[] = [
        {
            value: TAB_KEY.INFORMATION_SETTING,
            label: t('words_title.forum_tab_information')
        },
        {
            value: TAB_KEY.SEO_SETTING,
            label: t('words_title.forum_tab_seo_setting')
        }
    ];
    return (
        <div>
            <Tabs value={activeTab} onValueChange={handleTabChange} className='w-full h-full flex flex-col'>
                <div className='bg-white rounded'>
                    <TabsList variant='shop' data-orientation='horizontal' className='flex w-full mt-6 h-9'>
                        {SEO_TOOL_TAB_TYPE.map((item, index) => (
                            <TabsTrigger
                                key={index}
                                variant='shop'
                                className='text-3 w-full'
                                value={item.value}
                            >
                                {item.label}
                            </TabsTrigger>
                        ))}
                    </TabsList>
                </div>

                <div>
                    {SEO_TOOL_TAB_TYPE.map((item, index) => (
                        <TabsContent
                            key={index}
                            value={item.value}
                        >
                            {item.value === TAB_KEY.INFORMATION_SETTING && (
                                <div className=''>
                                    <TopicForm />
                                </div>
                            )}
                            {item.value === TAB_KEY.SEO_SETTING && (
                                <div>
                                    <SeoSetting seoEntityType={SEO_ENTITY_TYPE.TOPIC} />
                                </div>
                            )}
                        </TabsContent>
                    ))}
                </div>
            </Tabs>
        </div>
    );
});
